/*!
=========================================================
* 仕入先マスタ　詳細
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardHeader, CardTitle,
  Table, Row, Col,
} from "reactstrap";

import Request from '../../common/Request';
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import InputRadio from '../FormParts/InputRadio';
import {
  cst_supplier_type,
} from '../../variables/codes_map';
import WithRole from '../FormParts/ButtonWithRole';
import Format from '../../common/Format'
import OpenFaxModal from "../FormParts/OpenFaxModal";
import Definition from "../../common/Definition";
import FormatCode from "../../common/FormatCode";
import InputInvoice from "../ViewParts/InputInvoice";

const domain = "";

/*
*　クラス名：
*     Detail   ：詳細表示用クラス
*/
class Detail extends React.Component {
  /*
  *　関数・変数名：
  *     constructor     　：コンストラクタ関数
  *                         ロード時に1度だけ呼び出される
  *  パラメータ 説明：
  *     props            ：GETやPOSTなどのパラメータ入力値
  */  
  constructor(props) {

    /*
    *　関数・変数名：
    *     super     　      ：親のコンストラクターを呼び、thisを使えるようにする
    *  パラメータ 説明：
    *     props            ：GETやPOSTなどのパラメータ入力値
    */
    super(props);

    /*
    *　関数・変数名：
    *     this.state    ：stateの初期設定
    *  KEY 説明：（※）は必須
    * 
    *     ▼画面毎設定　
    *     supplier_id       ：詳細画面用のパラメータ
    *     
    *     ▼共通設定
    *     data              ：更新画面用の元データ格納変数
    *     view              ：新規・更新の判定用変数
    *                         true : 更新   false ： 新規登録      
    */   
    this.state = {
      supplier_id: this.props.match.params.supplier_id,
      data: {
        values:{}
      },
      value: "",
      copied: false,
      title:"仕入先マスタ情報詳細",
      pdata: []
    };

    this.supplier_bank_list = this.supplier_bank_list.bind(this);

    /*
    *　動的なデータの変更が詳細画面ではないため、
    *　constructorにて、詳細データを取得し、初期値に設定
    */     
    let params = {};
    var url = domain + '/api/supplier/' + this.props.match.params.supplier_id;
    /* ここから検索 */
    Request.get(url, params, res => {
      this.setState({ data: {
        values:{
          ...res.Data["supplier"],
        }
      },
      pdata: [
        ...res.Data["supplier_bank"]
      ]
      });
      var url = domain + '/api/landmark/lastupdate/' + res.Data["supplier"].lastupdate_user_id;
      var params = {};
      Request.get(url, params, res => {
        let tmp = this.state.data.values;
        tmp.lastupdate_user = res.Data;
        this.setState({data:{values:tmp}});
      });
  });

  }

  /*
  *　関数・変数名：
  *     render ：react.Componentで用意されているrender関数
  *              この関数内のタグが表示される
  *     
  */
  render() {
    console.log(this.state.pdata);
    const {values} = this.state.data
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.data.values)
    const SupplierBankList = this.supplier_bank_list;

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="6">
                      <CardTitle tag="h3" className="float-left">{this.state.title}</CardTitle>
                    </Col>
                    <Col md="6">
                      <ButtonWithRole button_id="BTN_M2_03_04320" className="float-right" onClick={() => { this.props.history.push('/supplier/update/' + values.ulid) }}>編集</ButtonWithRole>
                    </Col>
                  </Row>
                </CardHeader>
                <Col md="11" className="detail">
                  <SystemInfo
                    id_title='仕入先ID'
                    id_value={values.supplier_natural_id}
                    update_timestamp={values.update_timestamp}
                    update_user={values.lastupdate_user && values.lastupdate_user.name}
                    update_user_picture={values.lastupdate_user && values.lastupdate_user.picture} />

                  <CardTitle tag="h4" className="float-left">管理情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th className="double">管理情報</th> */}
                        <CustomTd 
                          label="メモ" 
                          name="SUPPLIER__system_memo" 
                          copy={false} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd label='削除フラグ'
                          name='SUPPLIER__delete_flag'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='出入禁止フラグ'
                          name='SUPPLIER__banned_flag'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                    </tbody>
                  </Table>
                  <CardTitle tag="h4" className="float-left">会社情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="5">管理会社情報</th> */}
                        <CustomTd label="仕入先種別（法人・個人）"
                            name="SUPPLIER__supplier_type"
                            rootData={this.state.data}
                            value={
                                <InputRadio options={cst_supplier_type}
                                  disabled={true} 
                                  />
                            } />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="会社名" 
                          name="SUPPLIER__supplier_name" 
                          copy={false} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="会社名（カナ）" 
                          name="SUPPLIER__supplier_name_kana" 
                          copy={true} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="電話番号1" 
                          name="SUPPLIER__supplier_tel" 
                          copy={true} 
                          value={Format.phone_number(values.supplier_tel)}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="電話番号2" 
                          name="SUPPLIER__supplier_tel2" 
                          copy={true} 
                          value={Format.phone_number(values.supplier_tel2)}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="FAX番号" 
                          name="SUPPLIER__supplier_fax" 
                          value={
                            <OpenFaxModal
                              data={values}
                              onClick={()=>this.props.faxModal.current.setFaxModal({
                                fax_recipient_name:values.supplier_name+" 御中",
                                fax_recipient_number:values.supplier_fax
                              })}
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="メールアドレス" 
                          name="SUPPLIER__supplier_email" 
                          copy={true} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="郵便番号" 
                          name="SUPPLIER__supplier_zip_code" 
                          copy={true} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        {/* <th rowSpan="3">所在地</th> */}
                        <CustomTd 
                          label="都道府県" 
                          name="SUPPLIER__supplier_prefecture" 
                          copy={true} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="市区町村" 
                          name="SUPPLIER__supplier_city" 
                          copy={true} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="番地" 
                          name="SUPPLIER__supplier_address" 
                          copy={true} 
                          data={values}
                        />
                      </tr>
                      <tr>
                        <CustomTd label="適格事業者区分"
                            name="SUPPLIER__invoice_business_type"
                            rootData={this.state.data}
                            value={
                                <InputInvoice
                                    label="適格事業者区分"
                                    labelOn={false}
                                    rows={false}
                                    names={{
                                      payment_type: false,
                                      business_type: "SUPPLIER__supplier_invoice_business_type",
                                      registration_number: "SUPPLIER__supplier_invoice_registration_number",
                                      with_unconfirmed : "SUPPLIER__supplier_invoice_business_type"
                                    }}
                                    rootData={this.state.data}
                                    validateCallback={this.validateCallback}
                                    visible={true}
                                    disabled={true}
                                    />
                            } />
                      </tr>
                    </tbody>
                  </Table>
                  <CardTitle tag="h4" className="float-left">口座情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        <th className="sub">口座種別/口座番号</th>
                        <th className="sub">銀行名/支店名</th>
                        <th className="sub">口座名義（カナ）</th>
                        {/*<th className="sub">反社確認</th>*/}
                      </tr>
                    {this.state.pdata.length>0 && this.state.pdata.map((data,index)=> {
                      return <SupplierBankList data={data} index={index} key={index}/>
                    })}
                    </tbody>
                  </Table>
                  <Button onClick={() => { this.props.history.push('/supplier') }} className="float-left">一覧に戻る</Button>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
  // 2022-07-20 
  supplier_bank_list ({data={},index}) {
    const {
      id,
      supplier_bank_account_kana,
    } = data
    const align={
      verticalAlign: "top",
      textAlign: "left"
    }
    return (
      <tr key={index}>
        <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_supplier_bank_detail', data)}} /></td>
        <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_supplier_bank',data)}} /></td>
        <td style={align}>{supplier_bank_account_kana}</td>
        {/*
        <td style={align}>{FormatCode.decode("cst_supplier_antisocial_forces_flag",data["antisocial_forces_flag"])}</td>
        */}
      </tr>
    );

  }
}

export default Detail;
